import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import GmtToLocal from "./GmtToLocal";

import SearchIcon from "@mui/icons-material/Search";
import { Input as InputField } from "@vds/inputs";
import { Input } from "antd";
import { isValidPhoneNumber } from "libphonenumber-js";
import moment from "moment-timezone";
import { fetchAllCameraAndFovsForRbac } from "../../api/DeviceServiceManager";
import {
  editTagEndPoint,
  fetchCVApplicationLocationEndPoint,
  fetchDiscoveredCamerasEndPointByCamera,
  fetchDiscoveredCamerasEndPointByCompanion,
  fetchEvidenceDetailsEndPoint,
  fetchEvidenceS3UrlEndPoint,
  fetchIncidentsEndPoint,
  fetchNotificationGroupsEndPoint,
  fetchVisionDevicesEndPoint,
  goToHomePositionEndPoint,
  isRedisSessionEnabled,
  ptzRelativeControlEndPoint,
  queryCameraCVApplicationEndPoint,
  setHomePositionEndPoint,
  startLiveStreamEndPoint,
  stopLiveStreamEndPoint,
  unsubscribeCameraCVApplicationEndPoint,
  updateIncidentStatusEndPoint,
  updateSiteLabelEndPoint,
} from "../../configuration";
import store from "../../store";
import { setError } from "../../store/actions";
import { DEVICE_CONSTANTS } from "../../constants/DeviceConstants";
import { CALIBRATION_MODES, CALIBRATION_MODE_VALUES } from "../../constants/cameraInfoConstants";
import { capitalizeWords } from "../../api/utils";
import axiosInstance from "../axiosInterceptor";
import { DEVICE_STORAGE_NAMES } from "../constants/devices";
import { getCompanion, getFieldOfVisions } from "./tableUtils";
import { QUERY_SAFE_CHAR_REGEX, ROUTES, SAFE_REDIRECT_ROUTES, UUID_REGEX } from "../constants/routesConstants";
import { STORAGE } from "../constants/storageConstants";
import { getRandomUUID } from "../../Token";
import { MONTH_DD_YYY_HR_MIN_SEC_AM_ZZZ, DATE_FORMAT_MMM_DD_YYYY,
  MONTH_DD_YYYY_Z,  HR_MIN_SEC_AM_ZZZ } from "../constants/statistics.dateConstants";

export function isItGateway(device) {
  return device?.parentdeviceid ? false : true;
}

/**
 * Analyzes the license overuse status based on the start date.
 * @param {string} overuseStartedOn - The start date of the overuse period.
 * @returns {'inactive' | 'grace_period' | 'expired'}
 */
export function getLicenseOveruseState(overuseStartedOn) {
  if (!overuseStartedOn || overuseStartedOn === "0001-01-01T00:00:00Z") {
    return "inactive";
  }
  const startDate = new Date(overuseStartedOn);
  const gracePeriodEndDate = new Date(startDate);
  gracePeriodEndDate.setDate(startDate.getDate() + 7);
  const currentDate = new Date();
  if (currentDate > gracePeriodEndDate) {
    return "expired";
  }
  if (currentDate >= startDate && currentDate <= gracePeriodEndDate) {
    return "grace_period";
  }
  return "inactive";
}

export const deviceHashMap = {
  "ts.device.gateway": "Gateways",
  "ts.device.gatewayChild": "Gateway Child Devices",
  "ts.device.tgAssetTracker": "GAT Devices",
  "ts.device.cHeAssetTracker": "Cat/Cas Devices",
  "ts.device.smartcam": "Smart Cameras",
  "ts.device.pushcam": "Push Cam Devices",
  "ts.device.dmp": "Dmp Devices",
  "ts.device.onvif": "Onvif Devices"
};

export const fetcher = (url) => fetch(url).then((r) => r.json());
export const fetcherForFunction = (funct) => funct.then((r) => r);

// This logic here may need to be re-visited
export function prepareDataForPieChart(deviceList) {
  let pieData = [];
  if (!deviceList || !deviceList.length > 0) return [];
  let groupData = groupBy(deviceList, "state");

  let groupedData = [];

  for (const key in groupData) {
    let name = key;
    if (isItGateway(groupData[key][0].kind)) {
      if (key === "ready") name = "Active";
      else if (key === "registered") name = "Pending Activation";
    } else {
      if (key.toLowerCase() === "registered" || key.toLowerCase() === "ready") name = "Active";
    }
    if (!groupedData[name]) {
      groupedData[name] = groupData[key];
    } else {
      groupedData[name] = [...groupedData[name], ...groupData[key]];
    }
  }
  for (const key in groupedData) {
    pieData.push({
      id: key,
      value: groupedData[key].length,
      label: `${key} : ${groupedData[key].length}`, //Here is where the Active:9 is at
      component: groupedData[key],
      isGateway: isItGateway(groupedData[key][0].kind)
    });
  }

  return pieData;
}

export let groupBy = function (xs, key) {
  if (xs) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  } else {
  }
};

function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function buildChildren(deviceList) {
  let dmpList = [];
  let gatewayList = [];
  let gatGatewayList = [];
  for (let j = 0; j < deviceList.length; j++) {
    if (deviceList[j].kind === "ts.device.dmp") dmpList.push(deviceList[j].id);
    if (deviceList[j].kind === "ts.device.gateway") gatewayList.push(deviceList[j].id);
    if (deviceList[j].kind === "ts.device.tgAssetTracker") gatGatewayList.push(deviceList[j].id);
  }

  for (let j = 0; j < deviceList.length; j++) {
    if (
      deviceList[j].trustee &&
      (dmpList.includes(deviceList[j].trustee) || gatewayList.includes(deviceList[j].trustee) || gatGatewayList.includes(deviceList[j].trustee))
    ) {
      for (let k = 0; k < deviceList.length; k++) {
        if (deviceList[j].trustee === deviceList[k].id) {
          deviceList[j].isChild = true;
          if (deviceList[k].children) {
            deviceList[k].children.push(deviceList[j]);
          } else {
            deviceList[k].children = [deviceList[j]];
          }
        }
      }
    }
  }
}

export function getImageByType(device) {
  if (device !== undefined) {
    //returns the image url for the given type
    let parentDevice = getParentDevice(device);
    let parentType = parentDevice["kind"];

    if (isItGateway(device)) {
      switch (true) {
        case device["kind"] === "ts.device.tgAssetTracker":
          return (
            <image
              src="https://thingspace.verizon.com/content/dam/thingspace-portal/solutions/critical-asset-sensor/CritialAssetSensor-graphic.svg"
              alt="Asset Tracking Gateway"
            />
          );
        case device["kind"] === "ts.device.gateway.iokey.ifm":
          return <image src="https://media.ifm.com/CIP/mediadelivery/rendition/cefe6d4ab9fa8a47a52e222751860e4a/-B900-FJPG/AIK050" alt="io_link Gateway" />;
        case device["kind"] === "ts.device.gateway.lorawan.multitech":
          return (
            <image
              src="https://www.multitech.com/documents/media/images/products/multiconnect/conduit/MT_Conduit_AEP_clear_hr1000px_8-2019.png"
              alt="lorawan Gateway"
            />
          );
        case device["kind"] === "ts.device.gateway.vision.companion":
        case device["kind"] === "ts.device.gateway.vision.companion":
          if (device.manufacturer === "BullSequana") {
            return <img src="https://atos.net/wp-content/uploads/2019/05/Atos-BullSequana-Edge-white-background-e1557947592136.jpg" alt="BullSequana Device" />;
          } else {
            return (
              <img
                src="https://static6.arrow.com/aropdfconversion/arrowimages/c3bc80263d9a81028d049f6c3dfaefd83ee2c0b1/945-13730-0050.jpg"
                alt="Vision Companion Gateway"
              />
            );
          }

        default:
          return (
            <image
              src="https://www.multitech.com/documents/media/images/products/multiconnect/conduit/MT_Conduit_AEP_clear_hr1000px_8-2019.png"
              alt="Gateway"
            />
          );
      }
    } else {
      switch (true) {
        case device["kind"] === "ts.device.ble" || parentDevice["kind"] === "ts.device.tgAssetTracker" || device["name"].includes("ble"):
          return <image src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFQ49CmXPVFNePMSrHNj0_GNEtALMlZyuNFQ&usqp=CAU" alt="ble Sensor" />;
        case parentType === "ts.device.gateway.iokey.ifm":
          return <image src="https://media.ifm.com/CIP/mediadelivery/rendition/6a8d9e0f4e86634aa291817975465a58/-B900-FJPG/SD5100" alt="io_link Sensor" />;
        case parentType === "ts.device.gateway.lorawan.multitech":
          if (device.fields && "Temperature" in device.fields) {
            return (
              <image
                src="https://www.multitech.com/documents/media/images/products/sensors/air-temp-humidity/Industrial_RBS306-ATH-EXT.png"
                alt="Lorawan Temperature Sensor"
              />
            );
          } else {
            return <image src="https://www.multitech.com/documents/media/images/products/sensors/movement/Indoor_RBS301-ABM.png" alt="Lorawan Door Sensor" />;
          }

        case device["qrcode"] === "00075fe0-a604-04a6-e05f-0700075fe05f" || device["qrcode"] === "00075fca-f8fa-faf8-ca5f-0700075fca5f":
          return <image src="https://resources-boschsecurity-cdn.azureedge.net/public/images/middle/ProductPhoto_Web_all_9007217773693451.jpg" alt="Camera" />;
        case device["qrcode"] === "15020314-0204-0408-1500-ec71db465af7" || device["qrcode"] === "00053234-0029-0127-2919-ec71dbe838cc":
          return <image src="https://home-cdn.reolink.us/wp-content/assets/2019/10/e1-zoom-340.png" alt="Camera" />;
        case device["kind"] === "ts.device.onvif":
          return <image src="https://home-cdn.reolink.us/wp-content/assets/2019/10/e1-zoom-340.png" alt="Camera" />;
        default:
          return <image src="https://media.ifm.com/CIP/mediadelivery/rendition/6a8d9e0f4e86634aa291817975465a58/-B900-FJPG/SD5100" alt="Sensor" />;
      }
    }
  }
}

export function getParentDevice(state) {
  let sessionDeviceList = JSON.parse(sessionStorage.getItem("deviceList")) || [];
  let parentDevice = {};
  if (sessionDeviceList?.length) {
    sessionDeviceList?.map((device) => {
      if (device["id"] === state?.parentdeviceid || state?.cameraObject?.parentdeviceid) {
        parentDevice = device;
        return parentDevice;
      } else {
        return "Device has no parent device";
      }
    });
  }

  return parentDevice;
}

export function getFieldNameFromState(state) {
  let fieldNames = Object.keys(state.fields);
  let fieldNameArray = [];
  if (fieldNames.length > 0 && fieldNames) {
    fieldNames.map((field) => {
      fieldNameArray.push(field);
    });
  } else {
  }
  return fieldNameArray;
}

export function setGateAndSensorArray(gatewayArray, sensorArray) {
  return gatewayArray && sensorArray;
}

export function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        Dashboard
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}
      >
        <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem>
        <MenuItem onClick={handleClose}>Logout</MenuItem>
      </Menu>
    </div>
  );
}

/**
 * To generate text to which should be displayed for the table filter
 * @param {stringify} valueProp
 * @param {string} value
 * @param {Function} callbackFun
 * @returns {string} displayText
 */

const getDisplayText = (valueProp, value) => {
  if (valueProp === "state") {
    return value === "ready" || value === "active" ? "Online" : "Offline";
  }
  return value;
};

/**
 * To create an array of items for the table filter
 * tableRow object and valueProp string are mandatory
 * @param {Object} item
 * @param {string} valueProp
 * @param {function} callbackFun
 * @returns {Array} filterList
 */
export const createTableFilterList = (tableRow = [], valueProp, filterType = null, callbackFun) => {
  // debugger;
  const filterList = [];
  if (tableRow?.length <= 0) return filterList;
  let uniqueObj = {};

  tableRow?.forEach((item, index) => {
    let value = typeof item[valueProp] === "string" && item[valueProp].trim() !== "" ? item[valueProp] : "";
    if (value && filterType === "TIME_FILTER") {
      value = GmtToLocal(value);
      value = value.split(" ").slice(0, 3).join(" ").trim();
    }
    if (valueProp === "severity") {
      value = `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
    }
    if (callbackFun) {
      value = callbackFun(value, tableRow);
    }

    if (value && !uniqueObj.hasOwnProperty(value) && !Array.isArray(value)) {
      uniqueObj = { ...uniqueObj, [value]: index };
      filterList.push({ text: getDisplayText(valueProp, value), value: value });
    }
  });
  return filterList;
};

export const campionFilter = (deviceList, valueProp) => {
  // debugger
  const filterList = [];
  if (deviceList && deviceList?.length > 0) {
    deviceList.forEach((d, i) => {
      const list = getCompanion(d.id, deviceList);
      filterList.push(...list);
    });
  }
  if (filterList.length > 0) {
    const uniqueNames = new Set(filterList.map((obj) => obj.name));

    const output = Array.from(uniqueNames).map((name) => ({
      text: name,
      value: name
    }));

    return output;
  }

  return [];
};

export const getCompanionFilterOptions = () => {
  let companionList = JSON.parse(sessionStorage.getItem("companionDevicesList"));

  // Check if companionList is null or undefined
  if (!companionList) {
    console.error("Companion list is null or undefined");
    return [];
  }

  // Ensure companionList is an array before proceeding
  if (!Array.isArray(companionList)) {
    console.error("Companion list is not an array");
    return [];
  }

  const output = companionList?.map((name) => ({
    text: name.name,
    value: name.id
  }));
  return output;
};

export const getFovFilterList = (deviceList) => {
  let filteredDevices = deviceList?.filter((device) => device.kind === "ts.device.onvif.fov");

  const output = filteredDevices?.map((device) => ({
    text: device.name,
    value: device.parentdeviceid
  }));
  return output;
};

/**
 * To create Static filiter list
 * @param {Object} obj
 * @returns array of text and value field obj
 */
export const createTableFilterStaticList = (obj) => {
  if (obj.page === "Alerts" && obj.key === "Status") {
    return [
      { text: "Read", value: "Read" },
      { text: "Closed", value: "Closed" },
      { text: "New", value: "New" }
    ];
  }
  if (obj.page === "Rules") {
    return obj.key === "Status"
      ? [
          { text: "Disabled", value: "disabled" },
          { text: "Enabled", value: "enabled" }
        ]
      : obj.key === "RuleType"
        ? [
            { text: "System", value: true },
            { text: "Custom", value: false }
          ]
        : [];
  }
};
/**
 * To sort alert table based on thier status
 * @param {Object} a
 * @param {Object} b
 * @returns {number} 1 or -1 for sorting
 */
export const createSorterForAlertStatus = (a, b) => {
  const status = { Closed: 3, Read: 2, New: 1 };
  return status[a.iscleared ? "Closed" : a.isacknowledged ? "Read" : "New"] < status[b.iscleared ? "Closed" : b.isacknowledged ? "Read" : "New"] ? -1 : 1;
};

export const createSorterForIncidentStatus = (a, b) => {
  const status = { Reviewed: 3, Falsepositive: 2, New: 1 };
  return status[a.isreviwed ? "Reviewed" : a.isfalsepositive ? "Falsepositive" : "New"] <
    status[b.isreviwed ? "Reviewed" : b.isfalsepositive ? "Falsepositive" : "New"]
    ? -1
    : 1;
};
export const getIncidentsData = async (fetchIncidentReq) => {
  let payload;
  if (fetchIncidentReq === undefined) {
    payload = {
      filter: {
        selection: {
          eventtype: "",
          starttime: "",
          endtime: "",
          status: "Unresolved",
          siteid: "",
          severity: ""
        },
        sort: [
          {
            order: "recent"
          }
        ],
        limitnumber: 10,
        page: "",
        pagenumber: 1
      }
    };
  } else {
    payload = fetchIncidentReq;
  }
  try {
    const response = await axiosInstance.post(fetchIncidentsEndPoint(), payload);
    return { res: response.data.data, headers: response.data };
  } catch (e) {
    throw new Error({ error: true, message: e });
  }
};
export const unSubscribeCVApp = async (deploymentId, activeSession) => {
  try {
    const unSubRes = await axiosInstance.post(unsubscribeCameraCVApplicationEndPoint(), {
      accountname: activeSession?.accountId,
      resourceidentifier: {
        id: deploymentId
      }
    });
    const unSub = unSubRes.data;
    const status = unSubRes.status;
    // if (status == 200) {
    return status;
  } catch (error) {
    const errorMessage = error?.response?.data?.error_description;
    console.error("Failed to CV App unsubscription", error);
    handleApiError("warning", errorMessage ? errorMessage : "CV App unsubscription failed, please try again.");
    return [];
  }
  // console.log("result is ", unSub);
  // console.log("CV App unsubscription successful");
  // } else {
  //   return 500;
  // }
};
export const fetchCameraCVApps = async (id, activeSession, allCVApps) => {
  try {
    if (id !== undefined && id !== "") {
      const fetchCameraCVAppsRsp = await getCVAppData(id, activeSession);
      // debugger;
      if (fetchCameraCVAppsRsp.error) {
        return [];
      }

      let filterList = (fetchCameraCVAppsRsp || [])
        .filter((item) => item.status === "deployed" || item.status === "deploying")
        .map((item) => ({
          ...item,
          appName: allCVApps?.find((cvApp) => cvApp.id === item.appid)?.name
        }));

      return filterList;
    } else {
      return [];
    }
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getCVAppData = async (deviceId, activeSession) => {
  try {
    const response = await axiosInstance.post(queryCameraCVApplicationEndPoint(), {
      accountname: activeSession?.accountId,
      filter: {
        $selection: {
          deviceid: deviceId
        }
      }
    });
    const res = response.data;
    return res || [];
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getCVAppDeploymentData = async (deploymentid, activeSession) => {
  try {
    const response = await axiosInstance.post(queryCameraCVApplicationEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id: deploymentid
      }
    });
    const res = response.data;
    return res || [];
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getCVAppLocationData = async (appId, activeSession) => {
  try {
    const response = await axiosInstance.post(fetchCVApplicationLocationEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id: appId
      }
    });
    const res = response.data;
    return res || [];
  } catch (e) {
    console.log(e);
    return;
  }
};

export const filterRoisWithCvappsAndSiteids = (cvAppConfigedList) =>{
const roiList = cvAppConfigedList.filter((roi) => {
        return (
          roi?.cvapps != undefined &&
          roi?.siteids !== undefined && 
          roi?.siteids?.length > 0 
        );
      });
      return roiList;
}

export const getCVAppLocationDataFromAppName = async (appId, activeSession, cvappList, cvAppConfigedList) => {
   const roiList = filterRoisWithCvappsAndSiteids(cvAppConfigedList);
  let appname = cvappList.find(f => f.id === appId)?.name;
  if (!appname) {
    return [];
  }
  let cvappIds = cvappList.filter(k => k.name === appname).map(m => m.id);

  let roiAppDetail = roiList.filter(l => cvappIds.includes(l.cvapps[0].id));
  
  let objList = [];
  roiAppDetail.forEach(element => {
    const obj = {
      "locationids":element?.customdata?.statisticstagids || element?.tagids,
      "deviceid": element?.id,
      "deploymentid": element?.deployments?.[0]?.id
    }
    objList.push(obj);
  });
    
    const res = objList;
    return res || [];
  
};

export const startLiveStream = async (data, activeSession) => {
  let resourceidentifier = getResourceIdentifierForDevice(data);

  try {
    const response = await axiosInstance.post(startLiveStreamEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: resourceidentifier
    });
    const res = { response: response.data, status: response.status };
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const stopLiveStream = async (data, activeSession) => {
  let resourceidentifier = getResourceIdentifierForDevice(data);
  try {
    const response = await axiosInstance.delete(stopLiveStreamEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: resourceidentifier
    });
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const cameraControl = async (resourceidentifier, { x, y, z }, { x1, y1, z1 }, activeSession) => {
  try {
    const response = await axiosInstance.patch(ptzRelativeControlEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: resourceidentifier,
      change: { x: x || 0, y: y || 0, z: z || 0 },
      speed: { x: x1 || 0, y: y1 || 0, z: z1 || 0 }
    });
    return response.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const cameraControlGoHome = async (resourceidentifier, activeSession) => {
  try {
    const response = await axiosInstance.post(goToHomePositionEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: resourceidentifier
    });
    return response.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const cameraControlSetHome = async (resourceIdentifier, activeSession) => {
  try {
    const response = await axiosInstance.post(setHomePositionEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: resourceIdentifier
    });
    return response.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const fetchEvidenceDetails = async (evidenceid, activeSession) => {
  try {
    if (evidenceid) {
      const response = await axiosInstance.post(fetchEvidenceDetailsEndPoint(), {
        accountname: activeSession.accountId,
        evidenceid: evidenceid
      });
      const res = response.data;
      return res;
    } else {
      throw new Error("no evidence id");
    }
  } catch (e) {
    console.log(e);
    return;
  }
};

export const fetchEvidenceS3Url = async (mediaId, activeSession) => {
  try {
    if (mediaId) {
      const response = await axiosInstance.post(fetchEvidenceS3UrlEndPoint(), {
        accountname: activeSession.accountId,
        resourceidentifier: { id: mediaId }
      });
      return response.data;
    } else {
      throw new Error("no mediaId");
    }
  } catch (e) {
    console.log(e);
    return;
  }
};

/**
 * Toggle play/pause for video player with stream control and position tracking
 * @param {boolean} playing - Current playing state
 * @param {React.MutableRefObject} playerRef - Reference to video player
 * @param {React.MutableRefObject} currentTimeRef - Reference to store current time and duration
 * @param {string} videoUrl - The video URL to stream
 */
export const togglePlayPause = (playing, playerRef, currentTimeRef, videoUrl) => {
  const player = playerRef.current;
  const playerState = player.getState()?.player;
  
  if (playing) {
    // Pause: save time and stop stream
    playerRef.current.pause();
    currentTimeRef.current.seekTime = playerState.currentTime;

    if (!currentTimeRef.current.duration) {
      currentTimeRef.current.duration = playerState.duration;
    }
  } else {
    // Play: resume stream and restore position

    if (playerState.hasStarted && playerState.paused && playerState.currentTime < playerState.duration) {
      player.load();
      setTimeout(() => {
        player.seek(playerState.currentTime);
        playerRef.current.play();
      }, 100);
    } else {
      playerRef.current.play();
    }
  }
};

const dummyGateway = {
  id: "dummyGateway",
  name: "Boston Lab Gateway",
  kind: "ts.device.gateway",
  state: "ready",
  qrcode: "dummyGateway",
  fields: {},
  trustee: "dummyGateway",
  createdon: GmtToLocal("2023-10-13T23:31:01.000Z"),
  nickname: "LoRa Gateway",
  customdata: {
    location: "Boston Lab"
  }
};

const dummySensor = {
  id: "dummyGateway",
  name: "Boston Lab Vaping Sensor",
  kind: "ts.sensor.vaping",
  state: "ready",
  qrcode: "dummyGateway",
  fields: {},
  trustee: "dummyGateway",
  createdon: GmtToLocal("2023-10-13T23:32:01.000Z"),
  nickname: "LoRa Sensor",
  customdata: {
    location: "Boston Lab"
  }
};

//Get tag details for the companion and camera devices

export const editSiteTag = async (id, name, activeSession, imageid) => {
  try {
    const response = await axiosInstance.patch(editTagEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id
      },
      tag: {
        name,
        imageid
      }
    });
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    const errorMessage = e?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to update Campus, please try again.");
    return [];
  }
};
//Get tag details for the companion and camera devices

export const updateSiteLevelTagWithParkingCount = async (payload) => {
  try {
    const response = await axiosInstance.post(updateSiteLabelEndPoint(), payload);
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    const errorMessage = e?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to update Campus, please try again.");
    return [];
  }
};



export const updateSiteLevelTag = async (id, name, activeSession, imageid) => {
  try {
    const response = await axiosInstance.post(updateSiteLabelEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id
      },
      tag: {
        name,
        imageid
      }
    });
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    const errorMessage = e?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to update Campus, please try again.");
    return [];
  }
};

export const updateSiteTag = async (payload) => {
  try {
    const response = await axiosInstance.post(updateSiteLabelEndPoint(), payload);
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    const errorMessage = e?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to update Campus, please try again.");
    return [];
  }
};

export const editDescriptionTag = async (id, description, activeSession) => {
  try {
    const response = await axiosInstance.patch(editTagEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id
      },
      tag: {
        description
      }
    });
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const removeSiteFromCampus = async (siteId, tagId, activeSession) => {
  try {
    const response = await axiosInstance.patch(editTagEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id: siteId
      },
      tag: {
        tagids: [tagId]
      }
    });

    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    const errorMessage = e?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to add/remove site from campus, please try again.");
    return [];
    //throw new Error("Failed to remove site from campus");
  }
};

export const getCameraInfo = async (id, activeSession) => {
  console.log(id);
  const response = await axiosInstance.post(
    fetchDiscoveredCamerasEndPointByCompanion(),

    {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id
      },
      forcediscovery: true
    }
  );
  return response.data;
};

/**
 * To get all the device list data - this will be called onload and on reload of the device table
 */

export const refreshAllDeviceList = async (activeTab = 0, activeSession) => {
  try {
    const ACTIVE_TAB_CAMERA = 4;
    const ACTIVE_TAB_COMPANION = 3;
    const ACTIVE_TAB_SENSOR = 2;
    const ACTIVE_TAB_GATEWAY = 0;
    const ACTIVE_TAB_UNPAIRED = 1;
    const fetchData =
      activeTab === ACTIVE_TAB_COMPANION
        ? fetchVisionDevicesEndPoint
        : activeTab === ACTIVE_TAB_CAMERA
          ? fetchVisionDevicesEndPoint
          : activeTab === ACTIVE_TAB_GATEWAY
            ? fetchVisionDevicesEndPoint
            : fetchVisionDevicesEndPoint;

            let deviceList = [];
            let xNextToken = null;
            let totalCount = null;
            let isFirstRequest = true;
            const PAGE_LIMIT = 500;
            const MAX_PAGES = 50;
            const accountname = activeSession.accountId;
            let pageCount = 0;
    do {
      const body = isFirstRequest
        ? { accountname, filter: { $querytotalcount: true, $limitnumber: PAGE_LIMIT } }
        : { accountname, filter: { $page: xNextToken } };
      const response = await axiosInstance.post(fetchData(), body);
      if (!Array.isArray(response.data)) {
        deviceList = response.data;
        break;
      }
      if (isFirstRequest) {
        totalCount = parseInt(response.headers?.['x-total-count'] ?? '0', 10);
        isFirstRequest = false;
      }
      const prevLength = deviceList.length;
      deviceList.push(...response.data);
      pageCount += 1;
      // Guard against backend reporting an inconsistent x-total-count/x-next: if a page
      // added no new items, or we've paged an unreasonable number of times, stop instead
      // of looping forever on a stale next-page token.
      const madeProgress = deviceList.length > prevLength;
      xNextToken = (deviceList.length < totalCount && madeProgress && pageCount < MAX_PAGES)
        ? (response.headers?.['x-next'] || null)
        : null;
    } while (xNextToken);
    if (deviceList.error) {
      if (deviceList.error_description === "Invalid token type in Authorization header.") {
        alert("Invalid Token, Please login first");
      } else if (deviceList.error === "unauthorized_client") {
        alert("This user is not authorized to fetch device list, please log in as device user");
      } else if (deviceList.error === "bad_request") {
        alert("Bad request");
      }
      // sessionStorage.setItem("deviceList", JSON.stringify(deviceList));
      return;
    }

    if (deviceList.length === 0 && activeTab !== ACTIVE_TAB_SENSOR) {
      return;
    }

    if (activeTab === ACTIVE_TAB_GATEWAY) {
      let gatewayList = [];
      gatewayList = deviceList.filter((device) => device.kind === "ts.device.gateway");

      gatewayList = [...gatewayList, dummyGateway];
      sessionStorage.setItem(`${DEVICE_STORAGE_NAMES[activeTab]}`, JSON.stringify(gatewayList));
    }
    if (activeTab === ACTIVE_TAB_SENSOR) {
      let sensorList = [];
      sensorList = deviceList.filter((device) => device.kind === "ts.device.sensor");
      sensorList = [...sensorList, dummySensor];
      sessionStorage.setItem(`${DEVICE_STORAGE_NAMES[activeTab]}`, JSON.stringify(sensorList));
    }
    let newDeviceList = [];
    if (activeTab === ACTIVE_TAB_CAMERA || activeTab === ACTIVE_TAB_COMPANION) {
      let kind = "ts.device.gateway.vision.companion";
      if (activeTab === ACTIVE_TAB_CAMERA) {
        kind = "ts.device.onvif";
      }
      const filteredData = deviceList.filter((d) => d.kind === kind);
      await Promise.all(
        filteredData?.map(async (item, index) => {
          newDeviceList.push({ ...item }); // Use spread operator to clone the object
        })
      );
    }

    if (activeTab === ACTIVE_TAB_UNPAIRED) {
      try {
        let tableData = [];
        const companionDeviceList = JSON.parse(sessionStorage.getItem("companionDevicesList"));
        if (companionDeviceList?.length) {
          await Promise.all(
            companionDeviceList?.map(async (item) => {
              const resourceidentifier = getResourceIdentifierForDevice(item);
              const response = await axiosInstance.post(fetchDiscoveredCamerasEndPointByCompanion(), {
                accountname: activeSession.accountId,
                resourceidentifier: resourceidentifier,
                forcediscovery: true
              });

              let resData = response.data;
              if (resData?.length) {
                resData.forEach((cam) => {
                  cam.discoveredby = item.id;
                });
                tableData = tableData.concat(resData);
              }
            })
          );
          const outputArray = tableData?.map((obj) => ({
            ...obj,
            images: obj.fov?.map((item) => `data:image/png;base64,${item.snapshot}`)
          }));
          return outputArray;
        }
      } catch (e) {
        console.log(e);
      }
    }

    if (activeTab === ACTIVE_TAB_CAMERA) {
      sessionStorage.setItem(`${DEVICE_STORAGE_NAMES[activeTab]}`, JSON.stringify(newDeviceList));
      if (deviceList.length > 0) {
        await Promise.all(
          deviceList.map(async (d, index) => {
            // debugger;
            const list = getFieldOfVisions(d?.id, deviceList);
            if (list.length > 0) {
              // deviceList[index].children = list
            } else {
              // deviceList[index].children = []
            }
            // const res = await fetchCameraCVApps(d.id);
            deviceList[index].apps = [
              {
                id: "2ae1b085-1847-4af6-9e81-0f5a27b80f0e",
                appid: "43b15241-b389-4497-96c5-692849d5a69f",
                deviceid: "44c1e1b7-8978-60d4-e3f9-38c1a70ce05c",
                foreignid: "81012590-ef48-6394-e0dc-501d506b508e",
                billingaccountid: "",
                config: {
                  outputPriority: "Critical",
                  selectedGroup: "DEMO TESTING TO BE DELETED",
                  stream: "something"
                },
                status: "deployed",
                appName: "People Count"
              }
            ];
          })
        );
      }
    }
    if (activeTab === ACTIVE_TAB_COMPANION) {
      sessionStorage.setItem(`${DEVICE_STORAGE_NAMES[activeTab]}`, JSON.stringify(newDeviceList));
    }
    const deviceListOld = sessionStorage.getItem("deviceList");

    const combinedDeviceList = [...(deviceList || []), ...(deviceListOld ? JSON.parse(deviceListOld) : [])].reduce((uniqueDevices, device) => {
      const qrcodeExists = uniqueDevices.some((uniqueDevice) => uniqueDevice.refid === device.refid);
      if (!qrcodeExists) {
        uniqueDevices.push(device);
      }
      return uniqueDevices;
    }, []);

    sessionStorage.setItem("deviceList", JSON.stringify(combinedDeviceList));
    const dd = combinedDeviceList.map((obj) => {
      const parentDeviceId = obj.parentdeviceid;
      const matchingParents = combinedDeviceList.filter((item) => item.uid === parentDeviceId && item.kind === "ts.device.onvif.fov");

      if (matchingParents.length > 0) {
        const parentChildren = matchingParents.reduce((children, parent) => {
          if (parent.children && parent.children.includes(obj.name)) {
            return children;
          } else {
            return [...children, obj.name];
          }
        }, []);

        return {
          ...obj,
          children: parentChildren
        };
      } else {
        return {
          ...obj,
          children: []
        };
      }
    });
    return;
  } catch (error) {
    console.log(error);
  }
};
export const getDeviceMatchingRecordsList = async (id = null, activeSession, dispatch = null, setfunction = null) => {
  try {
    // debugger;
    // const response = await axiosInstance.post(fetchVisionDevicesEndPoint(), {
    //   accountname: activeSession.accountId,
    //   filter: {
    //     $sort: [{ field: "createdon", order: "desc" }],
    //     $expand: "fields",
    //   },
    // });
    const deviceList = await fetchAllCameraAndFovsForRbac(activeSession); //response.data;
    if (dispatch != null) {
      const fovlisTiem = deviceList.fovs.filter((f) => {
        return f.kind == "ts.device.onvif.fov";
      });
      dispatch(setfunction(fovlisTiem));
    }
    if (deviceList.error) {
      return [];
    }
    if (id !== null) {
      const matchingChildren = deviceList.fovs.filter((item) => item.parentdeviceid === id && item.kind === "ts.device.onvif.fov");
      return matchingChildren;
    } else {
      const filteredArray = deviceList.cameras.filter((item) => item.kind === "ts.device.onvif");
      console.log("filteredArray", filteredArray);
      const matchingRecords = filteredArray
        .map((onvifDevice) => {
          const parentId = onvifDevice.id;
          const matchingChildren = deviceList.fovs.filter((childDevice) => childDevice.parentdeviceid === parentId);
          if (matchingChildren.length > 0) {
            return { data: [...matchingChildren] };
          }
        })
        .filter((r) => r !== undefined);
      console.log("matchingRecords", matchingRecords);
      return matchingRecords;
    }
  } catch (error) {
    console.error(`getAllDeviceList ${error?.message}`);
  }
};

/**
 * To set the Detive nick name based on the kind property of the device / parent devcie
 */
export const setDeviceTypeNickName = (device, parent) => {
  let nickname;
  switch (device.kind) {
    case "ts.device.tgAssetTracker": {
      nickname = "BLE Gateway";
      break;
    }
    case "ts.device.dmp": {
      nickname = "Camera Gateway";
      break;
    }
    case "ts.device.gateway": {
      nickname = "TS Edge Gateway";
      break;
    }
    case "ts.device.ble": {
      nickname = "BLE Sensor";
      break;
    }
    case "ts.device.gateway.lorawan.multitech": {
      nickname = "Multitech Gateway";
      break;
    }
    case "ts.device.gateway.iokey.ifm": {
      nickname = "IOKey Gateway";
      break;
    }
    case "ts.device": {
      if (device.parentdeviceid) {
        let parentDevice = parent.uid === device.parentdeviceid ? parent : device;

        if (parentDevice) {
          if (parentDevice.kind.includes("lorawan")) {
            nickname = "LoRa Sensor";
          } else if (parentDevice.kind.includes("iokey")) {
            nickname = "IOKey Sensor";
          } else if (parentDevice.kind.includes("ts.device.tgAssetTracker")) {
            nickname = "BLE Sensor";
          } else {
          }
        } else {
          nickname = device.kind;
          console.log("No gateway info found for device: ", device.name, "parentdeviceid: ", device.parentdeviceid);
        }
      }
      break;
    }
    default: {
      nickname = device.kind;
    }
  }
  return { ...device, nickname };
};

export const getGateWayOrSensorHealthDetailData = (data = null) => {
  if (!data) return;

  const getBatteryPercent = (data, batteryLevel) => {
    if (data?.fields?.Supervisory?.BatteryLevel) {
      let batteryFormatted = parseFloat(batteryLevel.split(",")[0]);

      if (batteryFormatted >= 3) {
        batteryFormatted = 100;
      } else {
        batteryFormatted = parseFloat((batteryFormatted / 3) * 100);
      }
      return `${Math.round(batteryFormatted)}%`;
    } else if (data?.fields?.battery) {
      return `${batteryLevel}%`;
    } else {
      return "N/A";
    }
  };
  const getFormatedDays = (data) => {
    if (!data?.fields?.BatteryRemainingDays) return { val: "N/A", color: "" };
    const daysStr = data?.fields?.BatteryRemainingDays;
    return daysStr.slice(daysStr.length - 1) === "D"
      ? {
          val: `${daysStr.slice(0, daysStr.length - 1)} Days`,
          color: "var(--sasp-secondary-orange)"
        }
      : { val: daysStr, color: "var(--sasp-secondary-orange)" };
  };

  const getSignalStrengthInPercentage = (signalStrength) => {
    console.log(data);
    if (!signalStrength) return { value: "N/A", color: "" };

    let signalStrengthPercentage = "0%";
    let color = "red";
    if (signalStrength >= -30) {
      signalStrengthPercentage = "100%";
      color = "var(--sasp-primary-green)";
    } else if (signalStrength >= -55 && signalStrength < -30) {
      signalStrengthPercentage = "80%";
      color = "var(--sasp-primary-yellow)";
    } else if (signalStrength >= -67 && signalStrength < -55) {
      signalStrengthPercentage = "60%";
      color = "var(--sasp-secondary-orange)";
    } else if (signalStrength >= -80 && signalStrength < -67) {
      signalStrengthPercentage = "40%";
    } else if (signalStrength >= -89 && signalStrength < -80) {
      signalStrengthPercentage = "20%";
    } else if (signalStrength <= -90) {
      signalStrengthPercentage = "0%";
    } else {
      color = "red";
    }

    return { value: signalStrengthPercentage, color: color };
  };

  const signalStrength = data?.fields?.signalStrength || data?.fields?.rssi || data?.fields?.RSSILastUplink || "";
  const formattedSignalStrength = getSignalStrengthInPercentage(signalStrength);
  const batteryLevel = data?.fields?.battery || data?.fields?.Supervisory?.BatteryLevel || "";
  const deviceStatus = "Offline";
  if (data) {
    data.state === "ready" || data.state === "active" ? (deviceStatus = "Online") : (deviceStatus = "Offline");
  }
  const batteryPercentageString = getBatteryPercent(data, batteryLevel);
  const batteryPercentage = batteryLevel !== "" ? Number(batteryPercentageString.split("%")[0]) : 0;
  const remainingBatteryDays = getFormatedDays(data);
  const arrayData = [
    {
      name: "Battery Level",
      value: batteryPercentageString,
      textColor: batteryPercentage >= 90 ? "var(--sasp-primary-green)" : batteryLevel != "" ? "var(--sasp-secondary-orange)" : ""
    },
    {
      name: "Remaining days of battery life",
      value: remainingBatteryDays?.val,
      textColor: remainingBatteryDays?.color
    },
    {
      name: "Signal strength",
      value: formattedSignalStrength.value,
      textColor: formattedSignalStrength.color
    },
    {
      name: "Device status",
      value: deviceStatus,
      textColor: deviceStatus === "Online" ? "var(--sasp-primary-green)" : "var(--sasp-secondary-orange)"
    },
    { name: "% of missing data packages in 30 days", value: "N/A" },
    { name: "Network Current Status", value: "N/A" },
    { name: "Network Availability History (30 days)", value: "N/A" },
    { name: "Device Offline in past 30 days", value: "N/A" }
  ];
  return arrayData;
};

export const Base64ImageDecoder = (base64image) => {
  try {
    // Your base64-encoded image data
    const base64ImageData = `data:image/jpeg;base64,${base64image}`; // Replace with your base64 data

    // Decode the base64 image data
    const decodedImageData = atob(base64ImageData.split(",")[1]);

    // Convert the decoded data to a Uint8Array
    const uint8Array = new Uint8Array(decodedImageData.length);
    for (let i = 0; i < decodedImageData.length; i++) {
      uint8Array[i] = decodedImageData.charCodeAt(i);
    }

    // Create a Blob from the Uint8Array
    const blob = new Blob([uint8Array], { type: "image/jpeg" });

    // Create a URL for the Blob
    const imageUrl = URL.createObjectURL(blob);

    return imageUrl;
  } catch (error) {
    return;
  }
};
export const Base64VideoDecoder = (base64image) => {
  // Your base64-encoded image data
  const base64ImageData = `data:video/mp4;base64,${base64image}`; // Replace with your base64 data

  // Decode the base64 image data
  const decodedImageData = atob(base64ImageData.split(",")[1]);

  // Convert the decoded data to a Uint8Array
  const uint8Array = new Uint8Array(decodedImageData.length);
  for (let i = 0; i < decodedImageData.length; i++) {
    uint8Array[i] = decodedImageData.charCodeAt(i);
  }

  // Create a Blob from the Uint8Array
  const blob = new Blob([uint8Array], { type: "video/mp4" });

  // Create a URL for the Blob
  const imageUrl = URL.createObjectURL(blob);

  return imageUrl;
};

export const timeAgo = (dateString) => {
  const currentDate = new Date();
  const date = new Date(dateString);
  const timeDifference = currentDate - date;
  const minutes = Math.floor(timeDifference / (1000 * 60));
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return days === 1 ? "1 day ago" : `${days} days ago`;
  } else if (hours > 0) {
    return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  } else if (minutes > 0) {
    return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  } else {
    return "Just now";
  }
};

export const getLocationName = (evidence) => {
  const cameraList = JSON.parse(sessionStorage.getItem("camerasList"));
  const data = cameraList?.filter((dev) => dev.refid === evidence?.sourceId);
  if (evidence?.sourceId && data?.[0]?.customdata?.location) {
    return data?.[0]?.customdata?.location;
  } else return "NA";
};

export const getCameraRefId = (id) => {
  const cameraList = JSON.parse(sessionStorage.getItem("camerasList"));
  const data = cameraList?.find((dev) => dev?.id === id);
  if (data) {
    return data?.refid;
  }
};

export const getStatusColor = (status) => {
  let fillColor;
  switch (status?.toLowerCase()) {
    case "resolved":
      fillColor = "green";
      break;
    case "unresolved":
      fillColor = "black";
      break;
    default:
      fillColor = "black";
  }

  return fillColor;
};

export const getPriorityColor = (priority) => {
  let fillColor;
  switch (priority?.toLowerCase()) {
    case "low":
      fillColor = "blue";
      break;
    case "critical":
      fillColor = "orange";
      break;
    case "elavated":
      fillColor = "yellow";
      break;
    case "minor":
      fillColor = "blue";
      break;
    default:
      fillColor = "black";
  }

  return fillColor;
};

export const getTimeBasedOnGivenDate = (date) => {
  try {
    return new Intl.DateTimeFormat("default", {
      hour12: true,
      hour: "numeric",
      minute: "numeric",
      timeZoneName: "short"
    }).format(new Date(date));
  } catch (error) {
    console.error("date time error", error);
  }
};
export const convertCamelCaseToText = (text) => {
  const result = text?.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/&/g, " & ");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const convertNumToAvgTime = (duration1, duration2) => {
  return convertNumToTime((duration1 + duration2) / 2);
};

export const formatTime2 = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes > 0) {
    return `${minutes} Min`;
  } else {
    return `${remainingSeconds} Sec`;
  }
};

export const convertNumToTime = (duration) => {
  // Hours, minutes and seconds
  try {
    let hrs = ~~(duration / 3600);
    let mins = ~~((duration % 3600) / 60);
    let secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = "";

    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    if (secs > 30) {
      mins += 1;
    }

    ret += "" + mins + " min";

    if (mins < 1 && secs > 1) {
      ret += " " + secs + " sec";
    }

    return ret;
  } catch (error) {
    console.log(`duration is ${duration} error `, error);
    return "";
  }
};

export const updateSelectedIncident = async (payload, selectedIncident, activeSession) => {
  if (selectedIncident) {
    const response = await axiosInstance.patch(updateIncidentStatusEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id: selectedIncident.id
      },
      incident: { ...payload }
    });
    const updateIncidentsRsp = response.data;
    return updateIncidentsRsp;
  }
  throw "error";
};

export const notificationGroupAPI = async (activeSession) => {
  const response = await axiosInstance.post(fetchNotificationGroupsEndPoint(), {
    accountname: activeSession.accountId
  });
  const data = response.data;
  return data;
};

export const formatTime = (seconds) => {
  if (seconds >= 3600) {
    const hours = Math.floor(seconds / 3600);
    // const remainingMinutes = Math.floor((seconds % 3600) / 60);
    return `${hours} hr`;
  } else if (seconds >= 60) {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} min`;
  } else {
    return `${seconds} sec`;
  }
};
const isItCustomTime = (timeString) => {
  const array = timeString.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z/g);
  if (array?.length === 2) {
    return true;
  }
  return false;
};

export const calculateDateRangeForGraph = (timeRange, cameraId = null) => {
  let interval = sessionStorage.getItem("interval");
  console.log("ZoomSession", interval);
  const isNumericString = typeof timeRange === "string" && !isNaN(timeRange);
  const numericTimeRange = isNumericString ? Number(timeRange) : timeRange;

  if (typeof numericTimeRange === "number") {
    const result = {
      cameraId,
      dateRange: `(createdon > '${new Date(Date.now() - numericTimeRange * 1000).toISOString()}') `,
      interval: `${interval}m`
    };
    console.log("Number timeRange:", result);
    return result;
  } else if (typeof timeRange === "string" && isItCustomTime(timeRange)) {
    const dates = timeRange.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z/g);
    const startDate = new Date(dates[0]);
    const endDate = new Date(dates[1]);
    const durationInMS = endDate - startDate;
    const durationInHours = durationInMS / (1000 * 60 * 60);
    sessionStorage.setItem("customDuration", durationInHours);
    console.log("CustomDuration", durationInHours);
    const result = {
      cameraId,
      dateRange: `(createdon > '${new Date(dates[0]).toISOString()}') and (createdon < '${new Date(dates[1]).toISOString()}') `,
      interval: `${interval}m`
    };
    console.log("Custom timeRange:", result);
    return result;
  } else if (typeof timeRange === "string") {
    let dateRange;
    switch (timeRange) {
      case "Today":
        const today = new Date();
        const startTime = new Date(today.setHours(0, 0, 0, 0));
        const endTime = new Date();
        const durationInMS = endTime.getTime() - startTime.getTime();
        const durationInMHrs = durationInMS / (1000 * 60 * 60);
        const todayRange = durationInMHrs;
        sessionStorage.setItem("todayRange", todayRange);
        break;
    }
    const result = {
      cameraId,
      dateRange: `createdon > '${new Date(new Date().setHours(0, 0, 0, 0)).toISOString()}'`,
      interval: `${interval}m`
    };
    console.log("String timeRange:", result);
    return result;
  } else {
    const result = {
      cameraId,
      dateRange: `(createdon > '${timeRange[0].toISOString()}') and (createdon < '${timeRange[1].toISOString()}') `,
      interval: `${interval}m`
    };
    console.log("Array timeRange:", result);
    return result;
  }
};
export const calculateCounterRange = (timeRange) => {
  return {
    dateRange: `(createdon > '${new Date(new Date().setHours(0, 0, 0, 0)).toISOString()}') and (createdon < '${new Date(
      Date.now() - timeRange * 1000
    ).toISOString()}') `
  };
};

// export const calculateStartTime=(resetTime=undefined, deductTime=undefined)=>{
//   return resetTime ? `createdon > '${resetTime.toISOString()}'` :`createdon > '${new Date(new Date().setHours(0,0,0,0)).toISOString()}'` // '${new Date(Date.now() - deductTime * 1000).toISOString()}')
// }

export const calculateStartTime = (resetTime = undefined, deductTime = undefined) => {
  console.log("Deduct Time: ", deductTime);

  if (resetTime) {
    return `createdon > '${resetTime.toISOString()}'`;
  }

  if (typeof deductTime === "string") {
    if (deductTime.toLowerCase() === "today") {
      return `createdon > '${new Date(new Date().setHours(0, 0, 0, 0)).toISOString()}'`;
    }
    // If the deductTime string can be converted to a number
    if (deductTime.includes("-")) {
      return `(createdon > '${deductTime.slice(0, 24)}') and (createdon < '${deductTime.slice(25, 49)}')`;
    }

    deductTime = parseInt(deductTime, 10);
    if (!isNaN(deductTime)) {
      console.log("Converted deductTime to number:", deductTime);
      return `createdon > '${new Date(Date.now() - deductTime * 1000).toISOString()}'`;
    } else {
      console.log("Invalid deductTime string, reverting to default (Today)");
      return `createdon > '${new Date(new Date().setHours(0, 0, 0, 0)).toISOString()}'`;
    }
  }

  console.log("Fallback case: Using start of the current day");
  return `createdon > '${new Date(new Date().setHours(0, 0, 0, 0)).toISOString()}'`;
};

export const getResourceIdentifierForDevice = (deviceInfo) => {
  let resourceidentifier = {};
  let refidType = deviceInfo?.refidtype;
  let id = deviceInfo?.refid;
  if (refidType === "uuid") {
    refidType = "deviceid";
    id = deviceInfo?.id;
  }
  resourceidentifier[refidType] = id;
  return resourceidentifier;
};

export const getResourceIdentifierForCamera = (cameraIfo) => {
  let resourceidentifier = {};
  let refidType = cameraIfo?.refidtype;
  let id = cameraIfo?.refid;
  if (refidType === "uuid") {
    refidType = "qrcode";
    id = cameraIfo?.id;
  }
  resourceidentifier[refidType] = id;
  return resourceidentifier;
};

export const getSitesAndFloorsData = (siteTagList) => {
  if (siteTagList) {
    return JSON.parse(JSON.stringify(siteTagList));
  }
  return { sites: [], floors: [] };
};

export const getSiteNameById = (siteId, sitesList) => {
  const site = sitesList?.find((site) => site?.id === siteId);
  return site ? site.name : "";
};

export const getFloorNameById = (floorId, floors) => {
  const floor = floors?.find((floor) => floor.id === floorId);
  return floor ? floor?.name : "";
};
export const filterFloorsBySite = (floors, site) => {
  return floors?.filter((floor) => {
    return floor?.tagids?.includes(site);
  });
};

export const getFovImage = (streamImages, fovId) => {
  const img = streamImages?.filter((f) => f.id == fovId);
  return img == undefined ? "./assets/sample.png" : img?.[0]?.imageUrl;
};

export const SearchInput = ({ onChange, placeholder, addUsers }) => {
  return (
    <div>
      <style>
        {addUsers &&
          `
          .custom-input .ant-input::placeholder {
            color: #6F7171 !important; 
            background-color: transparent !important;
          }
          .custom-input .ant-input {
            color: black !important;
            background-color: transparent !important;
          }
        `}
      </style>
      <Input
        className={addUsers ? "custom-input" : ""}
        style={{
          width: "25%",
          minWidth: "300px",
          borderColor: addUsers ? "var(--gray-95, #f6f6f6)" : "black",
          borderLeftWidth: 0,
          borderTopWidth: 0,
          borderRightWidth: 0,
          borderRadius: 0,
          backgroundColor: addUsers ? "var(--gray-95, #f6f6f6)" : "white",
          boxShadow: addUsers ? "none" : "",
          borderBottom: addUsers && "1px solid black"
        }}
        prefix={<SearchIcon />}
        placeholder={placeholder}
        data-testid="searchInput"
        onChange={onChange}
      />
    </div>
  );
};

export const validateEmail = (email) => {
  const trimmed = email.trim();
  if (trimmed.includes("..")) return false;
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return emailRegex.test(email);
};

export const validatePhoneNum = (phoneNum) => {
  const phoneRegex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
  return phoneRegex.test(phoneNum) && phoneNum.length === 12;
};

export const formatDate = (date) => {
  const dateObj = new Date(date);
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObj.getDate().toString().padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${month}/${day}/${year}`;
};

export default SearchInput;

export const formatUTCTime = (utcTime) => {
  if (utcTime?.length > 0) {
    const date = new Date(utcTime);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const ampm = hours >= 12 ? "PM" : "AM";
    let hour = hours % 12;
    hour = hour ? hour : 12;
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;
    const secondsStr = seconds < 10 ? "0" + seconds : seconds;
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    const formattedTime = `${hours}:${minutesStr}:${secondsStr}`;
    const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
    const formatOnlyTime = `${hour}:${minutesStr} ${ampm}`;
    return { formattedTime, formattedDate, formatOnlyTime };
  } else {
    return { formattedTime: "NA", formattedDate: "NA" };
  }
};

export const formatLocalTime = (utcTime) => {
  if (utcTime?.length > 0) {
    const date = new Date(utcTime);
    console.log("testv1.2", date);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    console.log("testv1.3", hours, minutes, seconds);
    const ampm = hours >= 12 ? "PM" : "AM";
    let hour = hours % 12;
    hour = hour ? hour : 12;
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;
    const secondsStr = seconds < 10 ? "0" + seconds : seconds;
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const formattedTime = `${hours}:${minutesStr}:${secondsStr}`;
    const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
    const formatOnlyTime = `${hour}:${minutesStr} ${ampm}`;
    return { formattedTime, formattedDate, formatOnlyTime };
  } else {
    return { formattedTime: "NA", formattedDate: "NA" };
  }
};

export const convertDateFormat = (dateValue) => {
  if (!dateValue) {
    return { formatWithTime: "NA", formatWithoutTime: "NA", formatOnlyTime: "NA" };
  }
  const timeZone = moment.tz.guess();
  let date = moment(dateValue).tz(timeZone);
  if (!date.isValid()) {
    return { formatWithTime: "NA", formatWithoutTime: "NA", formatOnlyTime: "NA" };
  }
  let formatWithTime = date.format(MONTH_DD_YYY_HR_MIN_SEC_AM_ZZZ);
  let formatWithoutTime = date.format(DATE_FORMAT_MMM_DD_YYYY);
  let formatOnlyTime = date.format(HR_MIN_SEC_AM_ZZZ);
  return { formatWithTime, formatWithoutTime, formatOnlyTime };
};

export const formatETA = (eta) => {
  if (!eta && eta !== 0) return "";
  let totalSeconds;
  if (typeof eta === "string" && eta.includes(":")) {
    const parts = eta.split(":").map(Number);
    if (parts.length === 2) {
      totalSeconds = parts[0] * 60 + parts[1]; // mm:ss
    } else if (parts.length === 3) {
      totalSeconds = parts[0] * 3600 + parts[1] * 60 + parts[2]; // hh:mm:ss
    } else {
      return eta;
    }
  } else {
    totalSeconds = Number(eta);
  }
  if (isNaN(totalSeconds)) return "";
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const convertToTime = (duration) => {
  // Hours, minutes and seconds
  try {
    let dateObj = new Date(duration * 1000);
    let hours = dateObj.getUTCHours();
    let minutes = dateObj.getUTCMinutes();
    let seconds = dateObj.getSeconds();

    let timeString = hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");

    return timeString;
  } catch (error) {
    console.log(`duration is ${duration} error `, error);
    return "";
  }
};

export const convertToTimeWithValues = (duration) => {
  // Hours, minutes and seconds
  try {
    let dateObj = new Date(duration * 1000);

    let hours = dateObj.getUTCHours();
    let minutes = dateObj.getUTCMinutes();
    let seconds = dateObj.getSeconds();

    let timeString =
      hours > 0
        ? hours.toString() + ":" + minutes.toString().padStart(2, "0") + "h"
        : minutes > 0
          ? minutes.toString() + ":" + seconds.toString().padStart(2, "0") + "m"
          : seconds.toString() + "s";

    return timeString;
  } catch (error) {
    console.log(`duration is ${duration} error `, error);
    return "";
  }
};

export const convertToTimeWithNetValues = (duration) => {
  // Hours, minutes and seconds
  try {
    let dateObj = new Date(duration * 1000);
    let hours = dateObj.getUTCHours();
    let minutes = dateObj.getUTCMinutes();
    let seconds = dateObj.getSeconds();
    let timeString = hours > 0 ? hours + (minutes > 30 && 1) + "h" : minutes > 0 ? minutes + (seconds > 30 && 1) + "m" : seconds + "s";

    return timeString;
  } catch (error) {
    console.log(`duration is ${duration} error `, error);
    return "";
  }
};

export const getSiteInfoFromFloor = (floorId, siteTaglist) => {
  const locationList = siteTaglist;
  const sitesList = locationList?.sites;
  const floorInfo = locationList?.floors?.find((floor) => floor?.id === floorId);
  const siteInfo = sitesList.find((site) => floorInfo?.tagids?.includes(site?.id));
  return siteInfo;
};

export const fetchCompanionListByCamera = async (activeSession, cameraQR) => {
  try {
    const response = await axiosInstance.post(fetchDiscoveredCamerasEndPointByCamera(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        qrcode: cameraQR
      }
    });

    const res = response.data;
    return res;
  } catch (e) {
    throw new Error(e);
  }
};

export const isDuplicateCamName = (cameraList, camID, camName) => {
  return cameraList.find((camera) => camera.name === camName && camera.id != camID) ? true : false;
};

export const getLocationByCamera = (cameraid, cameraList) => {
  const camera = cameraList?.find((cam) => cam?.id === cameraid);
  if (!camera) {
    return {
      site: "NA",
      area: "NA",
      floor: "NA",
      cameraName: "NA"
    };
  }
  return {
    site: camera?.customdata?.location?.site?.name || "NA",
    area: camera?.customdata?.location?.area?.name || "NA",
    floor: camera?.customdata?.location?.floor?.name || "NA",
    cameraName: camera?.name || "NA",
    areaId: camera?.customdata?.location?.area?.tag || "NA",
    floorId: camera?.customdata?.location?.floor?.tag || "NA",
    siteId: camera?.customdata?.location?.site?.tag || "NA",
    subAreaId: camera?.customdata?.location?.subarea?.tag || "NA"
  };
};

export const getROIDatabyRoiID = (roiList, roiid) => {
  const matchedROI = roiList?.find((roi) => roi?.id === roiid);
  return matchedROI ? matchedROI?.customdata : [];
};

export const formatToTimeFrame = (dateObj) => {
  const dayOfweek = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
  const newDayArr = [];
  dayOfweek.forEach((weekday) => {
    for (const [key, val] of Object.entries(dateObj)) {
      if (weekday.slice(0, 2).toLowerCase() === key.toLocaleLowerCase() && val) {
        newDayArr.push(weekday);
      }
    }
  });

  return newDayArr;
};

export const dayMap = {
  SUNDAY: "Sundays",
  MONDAY: "Mondays",
  TUESDAY: "Tuesdays",
  WEDNESDAY: "Wednesdays",
  THURSDAY: "Thursdays",
  FRIDAY: "Fridays",
  SATURDAY: "Saturdays"
};

export const formatSelectedDays = (selectedDays) => {
  const formattedDays = selectedDays?.map((day) => dayMap[day]);
  if (formattedDays?.length > 1) {
    return `${formattedDays?.slice(0, -1).join(", ")} and ${formattedDays[formattedDays?.length - 1]}`;
  }
  return formattedDays[0];
};

export const formatTimeFrame = (startTime, endTime, selectedDays) => {
  selectedDays = Array.isArray(selectedDays) ? selectedDays : [selectedDays];

  if (startTime?.length === 0 || endTime?.length === 0) {
    return "  Always active";
  } else if (!selectedDays || selectedDays === "undefined") {
    return "  Always active";
  } else if (selectedDays === "Always active") {
    return "  Always active";
  } else {
    const allDays = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
    const weekends = ["SUNDAY", "SATURDAY"];
    const weekdays = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"];

    const allDaysSelected = allDays.every((day) => selectedDays?.includes(day)) && selectedDays?.length === 7;
    const weekendsSelected = weekends.every((day) => selectedDays?.includes(day)) && selectedDays?.length === 2;
    const weekdaysSelected = weekdays.every((day) => selectedDays?.includes(day)) && selectedDays?.length === 5;

    if (allDaysSelected) {
      return `Active between ${startTime} to ${endTime} on all days`;
    } else if (weekendsSelected) {
      return `Active between ${startTime} to ${endTime} on weekends`;
    } else if (weekdaysSelected) {
      return `Active between ${startTime} to ${endTime} on weekdays`;
    } else {
      const randomDays = formatSelectedDays(selectedDays);
      return `Active between ${startTime} to ${endTime} on ${randomDays}`;
    }
  }
};

export const getFormatedContactNumber = (contactNumber) => {
  if (!contactNumber) return "";
  const contactRegex = /^\d{3}-\d{3}-\d{4}$/;
  if (contactRegex.test(contactNumber)) {
    return contactNumber.trim();
  }
  let numericOnly = contactNumber.trim().replace(/[^\d]/g, "");
  if (numericOnly.startsWith("1") && numericOnly.length === 11) {
    numericOnly = numericOnly.substring(1);
  }
  if (numericOnly.length > 10) {
    numericOnly = numericOnly.slice(0, 10);
  }
  let formatedNumber = "";
  numericOnly.split("").forEach((item, index) => {
    if (index === 0) {
      formatedNumber += `${item}`;
    } else if (index === 3 || index === 6) {
      formatedNumber += `-${item}`;
    } else {
      formatedNumber += item;
    }
  });
  return formatedNumber;
};

export const isInvalidContactNumber = (numberStr) => {
  // Remove all non-digit characters
  const digits = numberStr.replace(/\D/g, "");

  // Check if the number has exactly 10 digits
  if (digits.length !== 10) return true;

  // Validate against real NANP structure (area code/exchange code rules,
  // unassigned/reserved ranges, etc.)
  return !isValidPhoneNumber(digits, "US");
};

export const getDisplayPhoneNumber = (mdn) => {
  if (!mdn) return "";
  let displayMdn = mdn;
  if (displayMdn.startsWith("+1")) {
    displayMdn = displayMdn.substring(2);
  }
  const formatted = getFormatedContactNumber(displayMdn);

  return formatted;
};

export const convertToIsoFormat = (time, isOverNight = false) => {
  if (!time || typeof time !== "string" || !time.includes(" ")) {
    return null;
  }

  const [timePart, period] = time?.split(" ");
  if (!timePart || !period || !timePart.includes(":")) {
    return null; // Return null if time format is invalid
  }

  let [hour, minute] = timePart?.split(":");
  hour = parseInt(hour, 10);
  minute = parseInt(minute, 10);

  if (isNaN(hour) || isNaN(minute) || hour < 0 || hour > 12 || minute < 0 || minute > 59) {
    return null;
  }

  if (period === "PM" && hour !== 12) {
    hour += 12;
  } else if (period === "AM" && hour === 12) {
    hour = 0;
  }

  // Get the current date
  const currentDate = new Date();

  const targetDate = new Date(currentDate);
  if (isOverNight) {
    targetDate.setDate(targetDate.getDate() + 1);
  }
  const currentDate_Date = targetDate.getDate();
  // Construct a local date object using the provided time
  const localDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate_Date, hour, minute);

  // Convert the local time to UTC
  const utcDate = new Date(localDate.toISOString());

  // Return the UTC time in ISO format
  return utcDate.toISOString()?.replace(".000", "");
};

export const getCompareSymbol = (value) => {
  const conditionText = value?.toLowerCase();
  if (conditionText === "greater than") {
    return ">";
  } else if (conditionText === "less than" || conditionText === "lesser than") {
    return "<";
  } else {
    return null;
  }
};

export const getTimeAbbreviation = (timeUnit) => {
  switch (timeUnit?.toLowerCase()) {
    case "minutes":
      return "m";
    case "seconds":
      return "s";
    case "hours":
      return "h";
    default:
      return null;
  }
};

export const getTimeUnit = (duration) => {
  const lastChar = duration && duration?.slice(-1);
  if (lastChar) {
    switch (lastChar) {
      case "m":
        return "minutes";
      case "h":
        return "hours";
      case "s":
        return "seconds";
      default:
        return "NA";
    }
  }
  return "NA";
};

export const validateCondition = (condition) => {
  const conditionText = condition?.toLowerCase();
  if (conditionText?.includes("greater than") || conditionText?.includes("lesser than") || conditionText?.includes("less than")) {
    return true;
  } else {
    return false;
  }
};

export const getLastWord = (condition) => {
  const words = condition?.split(" ");
  return words[words?.length - 1];
};

export const getLastSecThirdWords = (condition) => {
  const words = condition?.split(" ");
  if (words < 3) return null;
  return words?.slice(-3, -1)?.join(" ");
};

export const getFovSnapshot = (fovList, fovid) => {
  const fovObject = fovList && fovList?.find((fov) => fov.id === fovid);
  if (!fovObject) {
    return "NA";
  } else {
    return fovObject?.customdata?.imageid ? fovObject?.customdata?.imageid : "NA";
  }
};

export const getRoiParentdeviceId = (roiList, roiid) => {
  const roiObject = roiList && roiList?.find((roi) => roi.id === roiid);
  if (!roiObject) {
    return "NA";
  } else {
    return roiObject?.parentdeviceid ? roiObject?.parentdeviceid : "NA";
  }
};

export const getCompanionidbyCamera = (cameraList, cameraid) => {
  const cameraObject = cameraList && cameraList?.find((cam) => cam.id === cameraid);
  if (!cameraObject) {
    return "NA";
  } else {
    return cameraObject?.parentdeviceid;
  }
};

export const signInConfig = {
  client_credentials: {
    client_id: "5gVisionInsight",
    // redirect_uri: `http://localhost:3010/smartvision/esso/redirect`,
    redirect_uri: isRedisSessionEnabled()
      ? `${window.location.origin}${window.REACT_APP_SASP_UNIFIED_HOST_REDIS}/smartvision/esso/redirect`
      : `${window.REACT_APP_SASP_UNIFIED_HOST}/smartvision/esso/redirect`
  },
  oidc_provider: {
    // authorization_endpoint:
    //   "https://core-devint.thingspace.verizon.com/oidc/v1/authorization",
    authorization_endpoint: window.REACT_APP_KEY_CLOAK_AUTH_URL,
    kc_idp_hint: window.KEY_CLOAK_IDP_HINT
  },
  scopes:
    "openid ts.device ts.alert ts.audit ts.subscription ts.user ts.notifusergroup ts.tag ts.target ts.trigger saap.administrator dm.rbac dm.role dm.access"
};

export const clearAllCookies = () => {
  // Use document.cookie.split(';') to get an array of all visible cookies.
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    // Extract the name of the cookie
    const [name] = cookie.split("=");
    const cookieName = name.trim();

    // Set the expiration date to a past date (epoch) for deletion
    const pastDate = "expires=Thu, Jan 1 1970 00:00:00 GMT";

    // SECURITY NOTE: We cannot delete HttpOnly cookies, but we clear all visible ones.

    // 1. Delete for the current path/domain (most common case)
    document.cookie = `${cookieName}=; ${pastDate}; path=/`;

    // 2. Delete for the parent domain (crucial for .verizon.com subdomains)
    // This is necessary if cookies were set for the entire parent domain.
    document.cookie = `${cookieName}=; ${pastDate}; path=/; domain=.verizon.com;`;
  }
};

export const getFovDetailedStatus = (fov) => {
  const rawStatus = (fov?.Status || fov?.state || "").toLowerCase();
  const connectivity = (fov?.connectivityStatus || "").toLowerCase();

  if (connectivity === DEVICE_CONSTANTS.CAMERA_OFFLINE_STATUS) {
    return { status: capitalizeWords(DEVICE_CONSTANTS.CAMERA_OFFLINE_STATUS), color: "yellow" };
  }

  if (rawStatus === DEVICE_CONSTANTS.CAMERA_STATUS_READY) {
    return { status: DEVICE_CONSTANTS.CAMERA_ONBOARDED_STATUS, color: "" };
  }

  const calibration = fov?.fields?.calibration;
  const calibrationStatus = calibration?.status;

  // Not calibrated conditions
  if (rawStatus === DEVICE_CONSTANTS.CAMERA_STATUS_REGISTERED && (calibration === undefined || calibrationStatus < 0)) {
    return { status: DEVICE_CONSTANTS.CAMERA_NOT_CALIBRATED_STATUS, color: "yellow" };
  }

  // Calibrating condition
  if (rawStatus === DEVICE_CONSTANTS.CAMERA_STATUS_REGISTERED && calibrationStatus >= 0 && calibrationStatus < 100) {
    return { status: DEVICE_CONSTANTS.CAMERA_CALIBRATING_STATUS, color: "blue" };
  }

  return {
    status: convertCamelCaseToText(fov?.Status ? fov?.Status : fov?.state),
    color: "orange"
  };
};

export const getFovDetailedCalibrationType = (fov) => {
 if (fov?.state?.toLowerCase() == DEVICE_CONSTANTS.CAMERA_STATUS_READY) {
    return fov?.fields?.calibration?.mode ? convertCamelCaseToText(fov?.fields?.calibration?.mode) : CALIBRATION_MODE_VALUES.AUTOMATIC;
  } else if (fov?.state?.toLowerCase() == DEVICE_CONSTANTS.CAMERA_STATUS_REGISTERED && fov?.fields?.calibration?.status < 100) {
    return fov?.fields?.calibration?.mode ? convertCamelCaseToText(fov?.fields?.calibration?.mode) : CALIBRATION_MODE_VALUES.AUTOMATIC;
  } else if (fov?.state?.toLowerCase() == DEVICE_CONSTANTS.CAMERA_STATUS_REGISTERED && fov?.fields?.calibration == undefined) {
    return CALIBRATION_MODES.SKIPPED;
  } else {
    return fov.state ? convertCamelCaseToText(fov.state) : fov?.Status ? convertCamelCaseToText(fov?.Status) : "";
  }
};

export const getFovDetailedOnboardingType = (fov) => {
 return fov?.isManualAdded ? CALIBRATION_MODE_VALUES.MANUAL : CALIBRATION_MODE_VALUES.AUTOMATIC;
};

export const getLicenseTypeDisplayed = (licenseType, licenseList) => {
  if (!Array.isArray(licenseList)) {
    return convertCamelCaseToText("No license");
  }

  const license = licenseList.find((f) => f?.sku === licenseType || f?.displayName?.toLowerCase() === licenseType?.toLowerCase());

  if (!license) {
    return convertCamelCaseToText("No license");
  }

  return convertCamelCaseToText(license.displayName);
};

export const getTagAncestry = function (tagList, tagId, levels) {
  const tagMap = {};

  console.log("tagList", tagList);
  Object?.keys(tagList)?.forEach((category) => {
    tagList[category]?.forEach((tag) => {
      tagMap[tag?.id] = tag;
    });
  });

  const ancestry = [];
  let currentTag = tagMap[tagId];

  while (currentTag && levels > 0) {
    // ancestry.push(currentTag); //This is used for getting the entire object
    ancestry.push({
      id: currentTag?.id,
      name: currentTag?.name,
      kind: currentTag?.kind,
      value: "",
      description: currentTag?.description || ""
    });

    const parentTagId = currentTag?.tagids && currentTag?.tagids[0];
    currentTag = tagMap[parentTagId];
    levels--;
  }

  return ancestry.reverse();
};

export const findImageForList = function (images, id) {
  if (images) {
    const imageObj = images.find((image) => image.id === id);
    return imageObj;
  }
};

export const findImageID = function (streamList, streamId) {
  if (streamList) {
    const matchingStreamItem = streamList?.find((obj) => obj.id === streamId);
    const imageId = matchingStreamItem?.customdata?.imageid;
    const imagetimestamp = matchingStreamItem?.customdata?.imagetimestamp;
    return { imageId, imagetimestamp };
  } else return null;
};

export const findUnpairedImageID = function (streamList, streamId) {
  if (streamList) {
    let imageInfo = {};
    streamList?.forEach((camObj) => {
      return camObj?.fovs?.forEach((obj) => {
        if (obj.fovID === streamId) {
          return (imageInfo = {
            imageId: obj?.imageID,
            imagetimestamp: obj?.timestamp
          });
        }
      });
    });
    return imageInfo;
  } else return null;
};
export const encodeOrDecodeRtspCredentials = (url, decode = true) => {
  if (!url || typeof url !== "string") return url;

  // Regex to match: rtsp://username:password@host:port/path
  const match = url.match(/^rtsp:\/\/([^:]+):(.+)@([^:\/]+):(\d+)(\/.*)?$/);
  if (!match) return url;

  const [, username, passwordAndHost, host, port, path] = match;
  // const lastAt = passwordAndHost.lastIndexOf("@");
  // const password = lastAt !== -1 ? passwordAndHost.substring(0, lastAt) : passwordAndHost;
  const lastAt = url.lastIndexOf("@");
  const splitData2 = url.slice(0, lastAt);
  const splitData3 = splitData2.split("rtsp://");
  const [userName = "", pass = ""] = splitData3[1].split(":");

  // Decode only username and password

  const decodedPassword = decode ? decodeURIComponent(pass) : encodeURIComponent(pass);

  return `rtsp://${userName}:${decodedPassword}@${host}:${port}${path || ""}`;
};
export const truncateName = (text) => {
  if (text && text.length > 13) {
    return `${text.slice(0, 10)}...`;
  } else {
    return text;
  }
};

export const getdateTimeDiff = (toDateTime, fromDateTime) => {
  const fromDateTimeConverted = new Date(fromDateTime).getTime();
  const timeDifference = toDateTime - fromDateTimeConverted;
  const minutes = Math.floor(timeDifference / (1000 * 60));
  return minutes;
};

export const validatePassword = (password, email, currentUrl) => {
  const meetsLengthReq = password.length >= 8;
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasNum = /\d/.test(password);
  const hasRequiredChars = hasLower && hasUpper && hasNum;

  const containsEmail = email && password.length > 0 ? email.match(/.{5}/g)?.some((chunk) => password.includes(chunk)) : false;
  const containsUrl = currentUrl && password.length > 0 ? currentUrl.match(/.{3}/g)?.some((chunk) => password.includes(chunk)) : false;

  return {
    isValid: meetsLengthReq && hasRequiredChars && !containsEmail && !containsUrl,
    errors: {
      length: !meetsLengthReq,
      chars: !hasRequiredChars,
      email: containsEmail,
      url: containsUrl
    }
  };
};

export const handleApiError = (errorType, message) => {
  store.dispatch(
    setError({
      message: message,
      errorType: errorType
    })
  );
};

export const getCVAppNameFromApplicationId = (appliccationId, cvappList) => {
  const app = cvappList && cvappList?.find((f) => f?.image === appliccationId);
  const appName = app?.resources?.displayNameFull || app?.name;
  return appName;
};

export const convertTimeValue = (value) => {
  const unit = value.slice(-1);
  const number = value.slice(0, -1);

  switch (unit) {
    case "m":
      return `${number} minutes`;
    case "h":
      return `${number} hours`;
    case "s":
      return `${number} seconds`;
    default:
      return "Invalid value";
  }
};

export const getImageObj = (arr, type) => {
  if (Array.isArray(arr) && arr.length !== 0) {
    const obj = arr.find((i) => i?.mediaType === type && i?.hasMedia);
    if (typeof obj === "object") {
      return obj;
    }
    return null;
  }
  return null;
};

export const deployedRoiList = (roiList, filteredRoiList) => {
  const commonROIList = roiList?.filter((item) =>
    filteredRoiList.some((region) => region?.id === item?.id && item?.deployments && item?.deployments[0]?.status === "deployed")
  );
  if (!commonROIList) {
    return [];
  }
  return commonROIList;
};

export const converMinutetoSeconds = (value, unit) => {
  console.log({ value, unit });
  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numericValue) || numericValue <= 0) {
    return "";
  }
  switch (unit.toLowerCase()) {
    case "seconds":
      return value; //seconds
    case "minutes":
      return value * 60; //minutes to seconds
    case "hours":
      return value * 60 * 60; //hours to seconds
    default:
      return "";
  }
};

export const colorMapping = (color) => {
  switch (color?.toLowerCase()) {
    case "violet":
      return "#B03CFD";
    case "red":
      return "#EE0000";
    case "orange":
      return "#FF8027";
    case "yellow":
      return "#FED60E";
    case "green":
      return "#00B845";
    case "blue":
      return "#0089EC";
    case "purple":
      return "#84279E";
    case "pink":
      return "#FB42BC";
    case "brown":
      return "#79420F";
    case "grey":
    case "gray":
      return "#6F7171";
    case "black":
      return "#000000";
    case "white":
      return "#FFFFFF";
    case "light green":
      return "#71e88f";
    case "dark green":
      return "#027305";
    case "light blue":
      return "#5ad7ff";
    case "dark blue":
      return "#055189";
    case "dark gray":
    case "dark grey":
      return "#5c5b5b";
    case "medium gray":
    case "medium grey":
      return "#808080";
    case "light gray":
    case "light grey":
      return "#cbcbcb";
    case "violet":
      return "#ee81ee";
    default:
      return color?.toLowerCase();
  }
};

export const NumberInputField = ({
  label = "Parking capacity",
  isError,
  setIsError,
  value = "",
  onChange,
  appName = "",
  errorText = "Enter a value",
  height = "44px",
  width = "193px",
  helpertext
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Always display the entered value
    if (onChange) {
      onChange(inputValue);
    }
    if (!/^\d*$/.test(inputValue)) {
      // setIsError(true);
      return;
    } else {
      // setIsError(false);
    }
  };

  return (
    <InputField
      height={height}
      width={width}
      type="number"
      label={label}
      error={isError}
      onChange={handleChange}
      value={value}
      errorText={isError && !/^\d*$/.test(value) ? "Enter a valid number" : errorText}
      helperText={helpertext}
      helperTextPlacement="bottom"
    />
  );
};

export const getParkingCountValue = (tagidList, locationId) => {
  const locationTag = tagidList?.find((tag) => tag?.id === locationId);
  if (locationTag) {
    return locationTag?.parkingcount;
  }
};

export const getFullCVAppName = (appid, cvappList) => {
  const app = cvappList.find((f) => f?.id === appid);
  const appName = app?.resources?.displayNameFull || app?.name;
  return appName;
};

export const getLocationByTag = (tagidList, locationId) => {
  const locationTag = tagidList?.find((tag) => tag?.id === locationId);
  if (locationTag) {
    return {
      name: locationTag?.name,
      id: locationTag?.id
    };
  }
};
export const getSiteIds = (siteTaglist) => {
  const siteIds = [];
  siteTaglist && siteTaglist.length && siteTaglist.map((s) => siteIds.push(s.id));
  return siteIds;
};

export const formatTimeToBrowserTime = (utcTimestamp) => {
  try {
    const localDate = new Date(utcTimestamp);

    // Format the local time in 12-hour format with AM/PM
    const formattedTime = localDate.toLocaleTimeString("en-us", {
      hour: "numeric",
      minute: "numeric",
      hour12: true
    });

    return formattedTime;
  } catch (error) {
    console.error("Error converting UTC to local time:", error);
    return null;
  }
};

// Function to format the time range intValue to string
export function formatTimeRange(milliseconds) {
  const minutes = Math.floor(milliseconds / (60 * 1000));
  const hours = Math.floor(minutes / 60);

  if (hours > 0) {
    return `Last ${hours} hour${hours > 1 ? "s" : ""}`;
  } else {
    return `Last ${minutes} minute${minutes > 1 ? "s" : ""}`;
  }
}

// Format the selectedTimerValue
export const formatTimerValue = (timerValue) => {
  const unitMap = {
    m: "min",
    h: (num) => (num > 1 ? "hrs" : "hr")
  };
  return timerValue.replace(/(\d+)\s*(minutes?|hours?)/, (_, number, unit) => {
    const abbreviatedUnit = unitMap[unit.charAt(0)];
    return `${number} ${typeof abbreviatedUnit === "function" ? abbreviatedUnit(Number(number)) : abbreviatedUnit}`;
  });
};

export const getCookie = (name) => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="))
    ?.split("=")[1];
};

export const updateObjectWithDeltaIn = (target, source) => {
  const updatedObject = { ...target }; // Create a shallow copy

  Object.keys(target).forEach((key) => {
    if (key in source) {
      updatedObject[key] = source[key];
    }
  });

  return updatedObject;
};

export const setCookie = (cname, cvalue, minutes) => {
  var d = new Date();
  d.setTime(d.getTime() + minutes * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
};

export const parseColorsFromString = (objectColor) => {
  if (!objectColor || typeof objectColor !== "string") {
    return [];
  }

  return objectColor && objectColor?.split(",").map((color) => color.trim());
};

export const getStandardizedRole = (rawRole) => {
  if (!rawRole || typeof rawRole !== "string") return "";
  return rawRole.split(" ").join("_").toLowerCase();
};

/**
 * Helper function to check if a stream is in calibrating state
 * @param {Object} fov - Field of view (stream) object
 * @returns {boolean} - True if the stream is calibrating, false otherwise
 */
const isStreamCalibrating = (fov) => {
  const calibrationStatus = fov.fields?.calibration?.status;
  return (
    fov.state?.toLowerCase() === DEVICE_CONSTANTS.CAMERA_STATUS_REGISTERED.toLowerCase() &&
    calibrationStatus !== undefined &&
    calibrationStatus >= 0 &&
    calibrationStatus < 100
  );
};

/**
 * Check if streams are calibrating for given camera(s)
 * @param {string|Array} cameraIdOrList - Single camera ID (string) or list of camera objects (Array)
 * @param {Array} fovList - List of field of view (stream) objects
 * @returns {boolean} - True if any stream is calibrating, false otherwise
 */
/**
 * Check if any cameras in the list (or a specific camera) have streams that are currently calibrating
 * @param {string|Array} cameraIdOrList - Single camera ID string or array of camera objects
 * @param {Array} fovList - List of field of view (stream) objects
 * @returns {boolean} - True if any stream is calibrating, false otherwise
 */
export const checkStreamCalibration = (cameraIdOrList, fovList) => {
  if (!fovList || fovList.length === 0) {
    return false;
  }

  const cameraIds = typeof cameraIdOrList === "string" ? [cameraIdOrList] : cameraIdOrList?.map((cam) => cam.id) || [];

  if (cameraIds.length === 0) {
    return false;
  }

  return fovList.some((fov) => cameraIds.includes(fov.parentdeviceid) && isStreamCalibrating(fov));
};

export const getSessionStorageData = (key) => {
  const data = sessionStorage.getItem(key);
  if (!data) return null;

  try {
    return JSON.parse(data);
  } catch (error) {
    console.error(`Error parsing ${key} from sessionStorage:`, error);
    return null;
  }
};

export const getLocalStorageData = (key) => {
  const data = localStorage.getItem(key);
  if (!data) return null;

  try {
    return JSON.parse(data);
  } catch (error) {
    console.error(`Error parsing ${key} from localStorage:`, error);
    return null;
  }
};

 export const getDateforUsers = (userItem) => {
    const timeZone = moment.tz.guess();
    const formatted = moment(userItem?.createdon).tz(timeZone);
    return formatted.format(MONTH_DD_YYYY_Z);
  };

export function buildSiteDeviceMap(siteList, deviceList) {
  return siteList?.reduce((acc, site) => {
    deviceList?.forEach((device) => {
      if (Array.isArray(device.siteids) && device.siteids.includes(site.id)) {
        if (!acc[site.id]) acc[site.id] = { site, companions: [] };
        acc[site.id].companions.push(device);
      }
    });
    return acc;
  }, {});
}

export function getAllSitesAndCompanions(siteDeviceMap) {
  const siteIds = Object.keys(siteDeviceMap || {});
  const companionIds = [...new Set(Object.values(siteDeviceMap || {}).flatMap((entry) => entry.companions.map((c) => c.id)))];
  return { siteIds, companionIds };
}

export function getAdjustedAvailableLicenses(enrolledAppearanceLicense, hasAnyAppearanceSelected, action, wasEADeployed, totalLicensesAvailableFallback) {
  const shouldDeduct = hasAnyAppearanceSelected && !(action === "update" && wasEADeployed);
  const base = enrolledAppearanceLicense?.availablelicenses ?? totalLicensesAvailableFallback;
  return Math.max(0, shouldDeduct ? base - 1 : base);
}

